import {
  Component, inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent }       from '../sidebar/sidebar.component';
import { TopbarComponent }        from '../topbar/topbar.component';
import { ToastHostComponent }     from '../../components/toast-host/toast-host.component';
import { TosAcceptanceComponent } from '../../../features/tos/tos-acceptance.component';
import { MobileDrawerComponent }  from '../mobile-drawer/mobile-drawer.component';
import { LayoutService }          from '../../../core/services/layout.service';
import { UnexpectedErrorModalComponent } from '../../components/unexpected-error-modal/unexpected-error-modal.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    SidebarComponent,
    TopbarComponent,
    ToastHostComponent,
    TosAcceptanceComponent,
    MobileDrawerComponent,
    UnexpectedErrorModalComponent,
  ],
  templateUrl: './main-layout.component.html',
})
export class MainLayoutComponent {
  protected readonly layout = inject(LayoutService);
}
